import {
  TableComposable,
  Tbody,
  InnerScrollContainer,
} from '@patternfly/react-table'
import * as React from 'react'
import { useCallback } from 'react'

import type {
  MedicationDosageUnit,
  MedicationRoute,
  PatientMedicationHistory,
  PatientMedicationRecord,
  PatientMedication,
  PatientMedicationRecordEntry,
  MedicationFrequencyUnit,
} from '@app/domain/patient-medication-history/patient-medication-history.interface'
import { getLocalDate } from '@app/lib/time'

import { MedicationListHeader } from './medication-history-table-header'
import { MedicationHistoryRow } from './medication-history-table-row'

interface Props {
  addMedicationRecord: (activeDate: string) => void
  addMedicationRecordEntry: (
    patientMedication: PatientMedication,
    medicationRecord: PatientMedicationRecord,
  ) => void
  editMedication: (
    patientMedicationId: string,
    medicationDosageUnitId: string,
    medicationRouteId: string,
    name: string,
  ) => void
  editRecordDate: (
    activeDate: string,
    medicationRecord: PatientMedicationRecord,
  ) => void
  deleteRecord: (medicationRecordId: string) => void
  deleteMedication: (patientMedicationId: string) => void
  editMedicationRecordEntry: (
    patientMedication: PatientMedication,
    medicationRecord: PatientMedicationRecord,
  ) => void
  medicationHistory: PatientMedicationHistory
  medicationRoutes: MedicationRoute[]
  medicationDosageUnits: MedicationDosageUnit[]
  medicationRecordEntries: PatientMedicationRecordEntry[]
  medicationFrequencyUnits: MedicationFrequencyUnit[]
}

export const MedicationHistoryTable = ({
  addMedicationRecord,
  addMedicationRecordEntry,
  editMedication,
  editMedicationRecordEntry,
  editRecordDate,
  deleteRecord,
  deleteMedication,
  medicationHistory,
  medicationRoutes,
  medicationDosageUnits,
  medicationRecordEntries,
  medicationFrequencyUnits,
}: Props) => {
  const handleAddMedicationRecord = useCallback(() => {
    addMedicationRecord(getLocalDate(new Date()))
  }, [addMedicationRecord])

  return (
    <InnerScrollContainer>
      <TableComposable
        aria-label="Sticky columns and header table"
        gridBreakPoint=""
        isStickyHeader
        isStriped
        borders={false}
        style={{ tableLayout: 'auto' }}
      >
        <MedicationListHeader
          addMedicationRecord={handleAddMedicationRecord}
          editRecordDate={editRecordDate}
          deleteRecord={deleteRecord}
          medicationRecord={medicationHistory.medicationRecords}
          medicationsExist={medicationHistory.medications.length > 0}
        />
        <Tbody>
          {medicationHistory.medications.map((patientMedication) => {
            return (
              <>
                <MedicationHistoryRow
                  addMedicationRecordEntry={addMedicationRecordEntry}
                  editMedication={editMedication}
                  editMedicationRecordEntry={editMedicationRecordEntry}
                  deleteMedication={deleteMedication}
                  medicationDosageUnits={medicationDosageUnits}
                  medicationFrequencyUnits={medicationFrequencyUnits}
                  medicationRecord={medicationHistory.medicationRecords}
                  medicationRoutes={medicationRoutes}
                  medicationRecordEntries={medicationRecordEntries}
                  patientMedication={patientMedication}
                />
              </>
            )
          })}
        </Tbody>
      </TableComposable>
    </InnerScrollContainer>
  )
}
